import { IsArray, IsDefined, ValidateNested } from 'class-validator';

import { Address } from '../address/address';

export class KladrSuggestionsResponse {
    @IsDefined()
    @IsArray()
    @ValidateNested({ each: true })
    public suggestions: Address[];

    constructor(data: Partial<KladrSuggestionsResponse>) {
        this.suggestions = data?.suggestions;
    }
}
